import { store } from '@/store'
import { NavigationGuardNext, Route } from 'vue-router'
import { getDeepLinkParams } from './router-helpers'

/**
 * SigninGuard
 * 
 * Checks for a 'signin' token set as a route query parameter.  If a token
 * is found, attempts to login an authenticated user
 */
export default async (to: Route, from, next: NavigationGuardNext) => {
    //  Create a 'pass' function
    const pass = (why: string): void => {
        store.getters.appDebug && console.log(`GUARD: signin-guard pass. (${why})`)
        return next()
    }

    //  Create a 'fail' function
    const fail = (why: string): void => {
        store.getters.appDebug && console.error(`GUARD: signin-guard stop. (${why})`)

        //  Get deep link params (if valid) for redirecting after signin
        const params = getDeepLinkParams(to)

        //  Redirect to signin
        return next(`/signin${params}`)
    }

    //  Check for the auto 'signin' token
    const token = to.query.signin || null

    //  If the token does NOT exist, we pass the guard
    if (!token) return pass('token not in query')

    //  Else, fetch the authenticated user with the token
    const auth = await store.dispatch('authUserGet', {'userToken': token})

    //  If the user does NOT exist, guard fails
    if (!auth.user) return fail('no user')

    //  Else, check for a tenant attached to the url
    const tenantId = to.query.tenant || null

    //  If a tenant id exists, load the tenant
    if (tenantId) await store.dispatch('tenantGet', tenantId)

    //  Guard passes!
    return pass('successful signin')
}
